export interface TimestampMixin {
  dateCreated?: number;
  dateUpdated?: number;
}

export enum AIChatBotLLMType {
  gpt_3_5_turbo = 'gpt_3_5_turbo',
  gpt_4o = 'gpt_4o',
}

export enum AIChatBotDataSourceType {
  file = 'file',
  website_link = 'website_link',
  simple_text = 'simple_text',
  question_answer = 'question_answer',
}

export interface AIChatBotCreate {
  name: string;
  modelType: AIChatBotLLMType;
  modelTemperature: number;
  instructions?: string;
}

export type AiChatbotJobType = 'scrape' | 'generate_faq';
export type AiChatbotJobStatus = 'in_progress' | 'completed' | 'error';

export interface AiChatBotJob {
  id: number;
  jobType: AiChatbotJobType;
  status: AiChatbotJobStatus;
}

export interface AIChatBot extends TimestampMixin {
  id: number;
  modelType: string;
  enabled: boolean;
  modelTemperature: number;
  instructions?: string;
  openaiAssistantId?: string;
  onboarded: boolean;
  jobs: AiChatBotJob[];
  customSchedulingLink?: string | null;
  calendarEventTypeId?: number | null;
  schedulingPriority?: SchedulingPriority | null;
  defaultRep?: number | null;
}

export interface AIChatBotDataSource extends TimestampMixin {
  id: number | string;
  aiChatbotId: number;
  sourceType: AIChatBotDataSourceType;
  isUsedForTraining?: boolean;
  isAiGenerated?: boolean;
  charactersCount?: number;
}

export interface FileDataSource extends AIChatBotDataSource {
  s3Key: string;
}

export interface WebsiteDataSource extends AIChatBotDataSource {
  url: string;
  s3Key?: string;
}

export interface TextDataSource extends AIChatBotDataSource {
  body: string;
}

export interface QADataSource extends AIChatBotDataSource {
  question: string;
  answer: string;
}

export type PolymorphicAIChatBotDataSource =
  | TextDataSource
  | QADataSource
  | WebsiteDataSource
  | FileDataSource;

export type PatchQADataSource = { _id_to_update: string } & QADataSource;

export enum SchedulingPriority {
  CUSTOM_LINK = 'CUSTOM_LINK',
  CALENDAR_EVENT = 'CALENDAR_EVENT',
}
